import React, { useEffect, useRef, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { getUserTokens } from '../../../_network/auth'
import { setTokens } from '../../../store/reducers/profileSlice'
import constants from "../../../config/constants"

const ISenderWrapper = () => {
  const isAuthenticated = useSelector(state => state.profile.isAuthenticated);
  const accessToken = useSelector(state => state.profile.access_token);
  const refreshToken = useSelector(state => state.profile.refresh_token);
  const clientAccountID = useSelector(state => state.profile.account_id);
  const iframeRef = useRef(null);
  const [iframeHeight, setIframeHeight] = useState("600px"); // Default height
  
  const dispatch = useDispatch()

  useEffect(() => {
    const accessTokenRefresh = async () => {
        const userTokens = await getUserTokens({ 
            grantType: 'refresh_token', 
            refreshToken: refreshToken ? refreshToken : "" 
        })
    
        if (userTokens && userTokens.access_token && userTokens.refresh_token) {
            dispatch(setTokens({ 
                access_token: userTokens.access_token, 
                refresh_token: userTokens.refresh_token 
            }))
            return {access_token: userTokens.access_token}
        }
        return {access_token: undefined}
    }

    const handleMessage = (event) => {
        if (event.data.iframeHeight) {
            setIframeHeight(`${event.data.iframeHeight}px`);
        }

        if (event.data.type === "TOKEN_EXPIRED") {
            console.log("Child app requests a new token");

            // Send a new token if available
            if (isAuthenticated && accessToken) {
                accessTokenRefresh().then((response) => {
                    if (response.access_token) {
                        iframeRef.current?.contentWindow.postMessage(
                            { type: "NEW_TOKEN", token: response.access_token, customerAccountId: clientAccountID },
                            "*"
                        );
                    }
                })
            } else {
                iframeRef.current?.contentWindow.postMessage(
                    { type: "NEW_TOKEN", token: null },
                    "*"
                );
            }
        }
    }

    window.addEventListener("message", handleMessage)
    return () => window.removeEventListener("message", handleMessage)
  }, [isAuthenticated, accessToken, refreshToken, clientAccountID, dispatch])

  const sendAuthData = () => {
    if (iframeRef.current) {
      iframeRef.current.contentWindow.postMessage(
        {
            accessToken: accessToken,
            customerAccountId: clientAccountID,
            primaryColor: "#854EFF",
            secondaryColor: "#69B1AF",
            uiMode: "light"
        },
        "*"
      )
    }
  }

  return (
    <iframe
      title="iSender"
      src={constants.iSenderURL}
      width="100%"
      height={iframeHeight}
      ref={iframeRef}
      style={{ border: "none" }}
      onLoad={sendAuthData}
    ></iframe>
  )
}

export default ISenderWrapper